"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSuspiciousActivityReportingDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.NoSuspiciousActivityReportingDescription = {
    priority: 3,
    label: 'fields.payload.mor_group_answers.no_suspicious_activity_reporting_description.label',
    fallbackLabel: 'If you are not required to report suspicious activities to the appropriate financial intelligence unit, please explain the legal or regulatory framework that exempts you from this requirement and describe any measures you have in place to address potential suspicious activities.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_requirement_for_suspicious_activity_reporting', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_requirement_for_suspicious_activity_reporting === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_requirement_for_suspicious_activity_reporting === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
